import React from 'react';
import { Title5 } from '@hz-design-system/web-ui';
import Classes from './ListingPrice.module.scss';

interface ListingPriceProps {
  price: string;
}

const ListingPrice: React.FC<ListingPriceProps> = ({ price }) => {
  return <Title5 className={Classes['hz-Listing-price']}>{price}</Title5>;
};

export default ListingPrice;
